import { Header, Footer } from '@webmotors/consumer-shared-ui';
import { useLayout } from './layout.hook';
import { layoutStyles } from './layout.styles';
import { SHARED_TEST_IDS } from '@/utils';
import type { TLayoutConfig } from './layout.types';

const Layout = ({ children }: TLayoutConfig) => {
	const { authToken, portalBaseUrl, isCheckoutRoute, footerConfig } = useLayout();

	return (
		<>
			<Header authToken={authToken} baseUrl={portalBaseUrl} />
			<main
				className={isCheckoutRoute ? layoutStyles.checkoutContent : layoutStyles.content}
				data-testid={SHARED_TEST_IDS.LAYOUT_MAIN}
			>
				{children}
			</main>
			<Footer {...footerConfig} />
		</>
	);
};

Layout.displayName = 'Layout';

export { Layout };
